
import {  Checkbox, KoDate, KoForm, KoFormBuilder, KoLoader, KoSelect, KoToast, Upload } from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './recurringBills.module.scss';
import ItemEntryCrud from './itemEntryCrud';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';
// import Driver from 'packages/drivers';
import { Country} from 'country-state-city';

const RecurringBillsCurd = ({form, handleFinish, initialValues }) => {
  // const [form] =KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);
  const [countriesList] = useState(Country.getAllCountries());

  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`This transaction is applicable for reverse charge`}</Checkbox>;

  const CountrySelect = ({ value, onChange }) =>
    <KoSelect showSearch value={value}
      onChange={(v) => onChange(v)}
      placeholder={'Select Country'}
      options={countriesList?.map((country) => ({
        label: country?.name,
        value: country?.isoCode
      }))} />;

      
  const RecurrenceValues = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekdays Only (Mon–Fri)', value: 'weekday' },
    { label: 'Weekly (Same Day)', value: 'weekly' },
    { label: 'Weekends Only (Sat–Sun)', value: 'weekends' },
    { label: 'Monthly (Same Date)', value: 'monthly' }
  ];
    
  const Recurrence = ({ value, onChange }) =>
    
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose recurrence'
      options={RecurrenceValues?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'ventors', label: 'Vendor', colSpan: 4, widget: Customers },
      { key: 'primaryDetails.nationality',label: 'Source Of Supply', colSpan: 2, widget: CountrySelect },
      { key: 'primaryDetails.nationality',label: 'Destination Of Supply', colSpan: 2, widget: CountrySelect },
      { key: 'Recurring Bills', placeholder: 'Bill', label: 'Profile Name' , colSpan: 2},
      { key: 'recurrence', label: 'Repeat Every', colSpan: 2, widget: Recurrence },

      { key: 'startDate', label: 'Start Date', colSpan: 2, widget: Date },
      { key: 'startDate', label: 'End Date', colSpan: 2, widget: Date },
      { key: 'paymentterms', placeholder: 'Enter Payment Terms', label: 'Payment Terms' , colSpan: 2},
      { key: 'reversecharge', colSpan: 4, label: '', widget: CheckBox },

      { key: '', label: 'Item Table', colSpan: 6, widget: () => <ItemEntryCrud form={form} handleFinish={handleFinish} initialValues={initialValues} /> }
    ]};


  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'documents'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }};

  const normFile = (e) => {
    return e?.file;
  };


  const uploadButton = (
    <div className={styles.dndArea}>
      <KoIcon name='AttachmentOutlined' />
      <div>Recurring Bills Attach File</div>
    </div>

  );
  const onRemoveFile = (d) => {
    console.log();
  };


  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  
  return (
    <div  className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <div className={styles.attachments}>
          {/* <div className={styles.attachmentsArea}>
            <Driver DeleteFile={false} action={true} fileType={initialValues?.documents?.aadharDetails?.file?.type} filePath={initialValues?.documents?.aadharDetails?.file.url} handleDelete={() => onRemoveFile(initialValues?.documents?.aadharDetails?.file)} />
          </div> */}
        
          <KoForm.Item
            name={"file"}
            valuePropName={"file"}
            getValueFromEvent={normFile}>

            <Upload {...props}
              className={styles.card}
              onRemove={onRemoveFile}
              showUploadList={{showPreviewIcon : false}}
              showPreviewIcon={true}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </KoForm.Item>
        </div>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};
export default RecurringBillsCurd;